module.exports = __webpack_public_path__ + "img/42.4b24fcb7.png";